/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-17 15:06:26
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-06-17 15:50:33
 * @FilePath: /zeelool-nextjs/src/app/(staitc-page)/style-hub/components/StyleHubList.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { getResourceData } from '@/api/public';
import InfiniteScroll from '@/components/InfiniteScroll';
import { useReporting } from '@/hooks/useReporting';
import useRouteInfo from '@/hooks/useRouteInfo';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { getCurrentScrollPercentage, getViewArea } from '@/utils/scroll';
import { isInZeloolApp } from '@/utils/tools';
import { useCallback, useEffect, useRef, useState } from 'react';
import StyleHubItem from './StyleHubItem';
interface StyleHubListProps {
  initialProducts: any[];
  initialTotal: number;
}

export default function StyleHubList({ initialProducts, initialTotal }: StyleHubListProps) {
  const [products, setProducts] = useState(initialProducts);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [total] = useState(initialTotal);
  // const [nomoreShow, setNomoreShow] = useState(initialTotal <= 32);
  const currency = useStore((state) => state.currency);
  const userInfo = useStore((state) => state.userInfo);
  const { cnName } = useRouteMetadata();
  // 记录最后的滚动状态，避免页面跳转时滚动位置被重置
  const lastScrollState = useRef({ viewAdvance: 0, viewArea: 1 });
  const [isWebViewVisible, setIsWebViewVisible] = useState(true);
  const handleWebViewVisibility = (event: CustomEvent<{ isVisible: boolean }>) => {
    setIsWebViewVisible(event.detail.isVisible);
    if (event.detail.isVisible) {
      trackPageView();
    }
  };
  const isInH5 = isInZeloolApp();
  useEffect(() => {
    if (isInH5) {
      window.addEventListener('appWebViewVisibility', handleWebViewVisibility);
      window.addEventListener('appLeave', trackPageLeave);
      return () => {
        window.removeEventListener('appWebViewVisibility', handleWebViewVisibility);
        window.removeEventListener('appLeave', trackPageLeave);
      };
    }
  }, []);

  // 埋点相关
  const { trackEvent } = useReporting();
  const enterTimer = useRef(Date.now());
  const { getFromRouterInfo } = useRouteInfo();
  /**
   * 神策埋点：页面离开
   * @TrackType sensorsdata
   * @EventType StandalonePage_Leave
   * @EventDesc 页面离开
   * @EventParams {
   *   page_name: 页面名称,
   *   view_advance: 浏览进度,
   *   view_duration: 浏览时长,
   *   view_area: 浏览区域,
   * }
   */
  const trackPageLeave = useCallback(() => {
    try {
      const viewDuration = Math.ceil((Date.now() - enterTimer.current) / 1000);

      // 页面滚动距离（屏数）
      const { viewAdvance, viewArea } = lastScrollState.current;

      trackEvent(
        {
          eventName: 'StandalonePage_Leave',
          properties: {
            page_name: cnName,
            view_advance: viewAdvance,
            view_duration: viewDuration,
            view_area: viewArea,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (error) {
      logger.error('StandalonePage_Leave tracking error:', error);
    }
  }, [trackEvent, cnName]);
  const trackPageView = useCallback(() => {
    enterTimer.current = Date.now();
    const { refer_page_name, refer_url_path } = getFromRouterInfo();
    trackEvent(
      {
        eventName: 'StandalonePage_View',
        properties: {
          page_name: cnName,
          refer_page_name,
          refer_url_path,
        },
      },
      [ProviderType.SENSORS],
    );
  }, [trackEvent, cnName]);

  const loadMoreData = async () => {
    if (loading || products.length >= total) return;

    try {
      setLoading(true);
      const response = await getResourceData({
        info: [
          {
            key: 'style_hub',
            page: page + 1,
            limit: 32,
            status: location.pathname.includes('776d767a2d6dfef576e7f9b344a58731') ? 2 : 1,
          },
        ],
      });
      setProducts((prev) => [...prev, ...response.data.info.style_hub.products]);
      setPage((prev) => prev + 1);
      // setNomoreShow(response.data.info.style_hub.total <= (page + 1) * 32);
    } finally {
      setLoading(false);
    }
  };

  // 页面进入时的埋点
  useEffect(() => {
    if (!isInH5) {
      trackPageView();
    }
    return () => {
      trackPageLeave();
    };
  }, []);

  // 定期更新滚动状态，避免页面跳转时丢失滚动信息
  useEffect(() => {
    const updateScrollState = () => {
      try {
        const viewAdvance = getCurrentScrollPercentage();
        const viewArea = getViewArea();
        lastScrollState.current = { viewAdvance, viewArea };
      } catch (error) {
        // 忽略错误，使用默认值
        logger.error('Error updating scroll state:', error);
      }
    };

    // 立即更新一次
    updateScrollState();

    // 监听滚动事件，实时更新滚动状态
    const handleScroll = () => {
      updateScrollState();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div className="grid grid-cols-[repeat(2,1fr)] gap-1 md:grid-cols-2 lg:grid-cols-4 md:gap-[16px] md:mt-[4.167vw] pb-[13.333vw] md:pb-[80px]">
        {products.map((item, index) => (
          <StyleHubItem
            key={index}
            item={item}
            currency={currency}
            userInfo={userInfo}
            index={index}
            isWebViewVisible={isWebViewVisible}
            isInH5={isInH5}
          />
        ))}
      </div>
      {products.length > 0 && (
        <InfiniteScroll
          loading={loading}
          onReachBottom={loadMoreData}
          page={page}
          total={total}
          limit={32}
          className="pb-[30px] lg:pb-[45px]"
        />
      )}
      {/* 无更多的信息已经在InfiniteScroll中处理 */}
      {/* <WapOnly>
        {nomoreShow && products.length !== 0 ? (
          <div className="flex items-center justify-center flex-nowrap pb-[13.333vw]">
            <p className="w-[10.667vw] h-[1px] bg-[#d0d4db]"></p>
            <span className="text-[3.2vw] text-[#666] mx-[2.133vw] top-1">No More</span>
            <p className="w-[10.667vw] h-[1px] bg-[#d0d4db]"></p>
          </div>
        ) : null}
      </WapOnly> */}
    </>
  );
}
